import { Cover, SelectedFile } from "@/types/types";

export const isSelectedFile = (
  fileMaybe: SelectedFile | Cover
): fileMaybe is SelectedFile => {
  return "selectedUrl" in fileMaybe;
};
